import React, {useEffect, useState, FC} from "react";
import Grid from "@mui/material/Grid";
import NextLink from "next-translate-routes/link";


interface ProfileFriendItemProps {
    username: string;
    photoUrl: string;
    displayName: string;
}

export const ProfileFriendItem: FC<ProfileFriendItemProps> = ({username, photoUrl, displayName}) => {


    return (
        <Grid item sx={{
            position: "relative",
            mr: 2,
            mb: 5
        }}>

            <NextLink href={{
                pathname: "/u/[username]",
                query: {username}
            }} passHref
                      legacyBehavior>
                <a>
                    <img
                        src={photoUrl}
                        alt={displayName}
                        style={{width: 100, height: 100, margin: "0 auto"}}
                    />
                    <div style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        color: "white",
                        background: "linear-gradient(transparent, rgba(0, 0, 0, .6))",
                        lineHeight: "1rem",
                        padding: 5,
                        fontWeight: 500,
                        fontSize: "0.9rem"
                    }}>{displayName}</div>
                </a>
            </NextLink>

        </Grid>
    );
}
